export default __webpack_public_path__ + "static/media/bitcoin.9c381e6f.svg";